import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: 9,
    height: 9,
    borderRadius: '50%',
    backgroundColor: 'var(--color-colored-dot-grey)',

    '&.color': {
      '&--green': {
        backgroundColor: '#1AA153',
      },
      '&--red': {
        backgroundColor: '#EA3131',
      },
      '&--orange': {
        backgroundColor: '#ff8500',
      },
    },
  },
}));

const ColoredDot = ({ classesName = '', color = 'grey' }) => {
  const classes = useStyles();

  return <span className={`${classes.root} ${classesName} color--${color}`} />;
};

export default ColoredDot;
